import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppMaterialModule } from '../app-material/app-material.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AppMaterialModule,
  ]
})
export class HoverMenuesModule { }
